export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14279.73ab38e4.jpg";